import { openSelectOptions, selectOption, cr_state } from '@/select-box.js';
import $ from 'jquery';
import PriseConstante from '@/views/consultations/prendre-constante'
import TraiterConduite from '@/views/consultations/modal-traiter-conduite'
import TraiterSoinsSansConsultation from '@/views/consultations/modal-traite-soins-sans-consultation'
import { openMenu, closeMenu, open_menu_state, convertDateToYyyyMmDd } from '@/function/function.js';
import moment from 'moment'

export default {
    name: 'dashboard-infirmier',
    components: {
        PriseConstante,
        TraiterConduite,
        TraiterSoinsSansConsultation
    },
    props: [],
    data() {
        return {
            user_id: 0,
            vm_state: open_menu_state,

            monthConsultationsLoading: false,
            jr_selected: 'Aujourd\'hui',
            mm_selected: 'Mars',
            consult_month_selected: {
                french: null
            },
            selectedConsultation: null,
            curr_state: cr_state,
            date: new Date(),
            monthsLatest: new Array(),

            drp_menu_class: [],

            liste_conduites: [], //  Liste des conduites du jour
            cat_loading: true,
            selectedConduite: null,
            selectedMoment: null,

            soin_selected: {},
            heure_selected: '',

            suite_is_loading: true,

            // SUITE DE SOINS TABLE
            fields: ['patient', 'sexe', 'contact', 'consultation', { key: 'est_valide', label: 'Validités' }],
            filter: "",
            tableIsBusy: true,
            perPage: 10,
            currentPage: 1,

            salle_is_loading: true,
            salle_is_empty: false,

            l_month: [
                { nth_month: 1, month: "Janvier" }, { nth_month: 2, month: "Février" },
                { nth_month: 3, month: "Mars" }, { nth_month: 4, month: "Avril" },
                { nth_month: 5, month: "Mai" }, { nth_month: 6, month: "Juin" },
                { nth_month: 7, month: "Juillet" }, { nth_month: 8, month: "Août" },
                { nth_month: 9, month: "Septembre" }, { nth_month: 10, month: "Octobre" },
                { nth_month: 11, month: "Novemebre" }, { nth_month: 12, month: "Décembre" }
            ],
            curr_month: '',
            stat_sante_loading: true,
            stat_sante_empty: false,

            stat_date: '',
            stats_more: false,
        }
    },

    watch: {
        curr_month() {
            this.getStatSante(1)
        }
    },

    computed: {
        /**
         * User Info
         * @returns
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        countEnAttente() {
            if (this.consultationsEnAttente == null) {
                return 0;
            } else {
                return this.consultationsEnAttente.length;
            }
        },

        monthConsultations() {
            return this.$store.getters['currentMonthConsultationsCount'];
        },

        months() {
            return this.monthsOfYear();
        },

        latestMonthsOfCurrentYear() {
            let index;

            for (index = 0; index < this.date.getMonth() + 1; index++) {
                this.monthsLatest[index] = this.months[index];

            }
            return this.monthsLatest;
        },

        consultationsEnAttente() {
            return this.$store.getters['consultationsEnAttente'];
        },

        countTodayConsultations() {
            return this.$store.getters['todayConsultationsCount']
        },

        currentMonth() {
            return this.latestMonthsOfCurrentYear[this.date.getMonth()];
        },

        //
        currentCAT() {
            return this.$store.getters['cat'];
        },

        suitesSoins() {
            return this.$store.getters['suitesDeSoins'];
        },

        /**
         * Suite de soins length
         * @returns 
         */
        rows() {
            return this.suitesSoins.length;
        },

        stats_sante() {
            return this.$store.getters['stats_sante'];
        },
    },
    mounted() {
        this.user_id = this.userCredentials.id

        this.$store.dispatch('getSuitesSoins', { auth_id: this.user_id}).then(() => {
            this.suite_is_loading = false
            this.tableIsBusy = false
        })

        this.consult_month_selected = this.currentMonth

        this.curr_month = {
            nth_month: this.consult_month_selected.nth_month,
            month: this.consult_month_selected.french
        }

        this.$store.dispatch('getCountMonthConsultations', { month: this.currentMonth.english })

        // statistique sante
        this.getStatSante(1)

        setTimeout(() => {
            $('.shw1').fadeIn()
        }, 500);

        setTimeout(() => {
            $('.shw2').fadeIn()
        }, 700);

        setTimeout(() => {
            $('.shw3').fadeIn()
        }, 900);

        setTimeout(() => {
            $('.shw4').fadeIn()
        }, 900);

        // Consultation en salle d'attente
        this.refreshSalleAttente()
        
        this.$store.dispatch('getCountTodayConsultations')

        setTimeout(() => {
            for (let i = 0; i < this.consultationsEnAttente.length; i++) {
                this.drp_menu_class[i] = 'drp_menu_pos' + this.consultationsEnAttente[i].id;
            }
        }, 1000);

        let date_cat = convertDateToYyyyMmDd.convertDate(this.date);
        this.$store.dispatch('getCurrCat', { consultation_id: 0, date_cat: date_cat }).then((response) => {
            console.log("--> current cat",response)
            this.liste_conduites = response
            this.cat_loading = false;
        });
        

        let t = this;

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (t.vm_state != 0) {
                    t.openMenu(t.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("select-box-o")) {
                if (t.curr_state != 0) {
                    t.openSelectOption(t.curr_state, 'slt-month')
                }
            }
        });

    },
    methods: {
        getStatSante(type_filtre) {
            this.stat_sante_loading = true
            var filter_stat = {}
            
            if (type_filtre == 1) { // FIltre par mois
                filter_stat = {
                    type_filtre: 1,
                    date: this.curr_month.nth_month
                }
            } else {
                filter_stat = {
                    type_filtre: 2,
                    date: this.stat_date
                }
            }
            
            this.$store.dispatch('getStatistiqueSante', filter_stat).then(() => {
                if (this.stats_sante.length > 0) {
                    this.stat_sante_empty = false

                    if (this.stats_sante.length > 3) {
                        this.stats_more = true
                    }
                } else {
                    this.stat_sante_empty = true
                }

                this.stat_sante_loading = false
            })
        },

        properJson(data){
            try {
               return JSON.parse(data)
            } catch(e){
                return data

            }
        },
        
        formatHour: function(date){
            let formattedDate = moment(date)

            return formattedDate.format('HH:mm');
        },
        
        changeSelectedConsultation: function(consultation) {
            this.selectedConsultation = consultation
        },
        customDateFormat(given_date) {
            if (!given_date) {
                given_date = new Date()
            }

            let only_date = "",
                only_hour = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            only_date = date.getDate() + "/" + month + "/" + date.getFullYear();
            let c_hour = date.getHours();
            let c_minute = date.getMinutes();
            if (c_hour < 10) c_hour = "0" + c_hour;
            if (c_minute < 10) c_minute = "0" + c_minute;
            only_hour = c_hour + ":" + c_minute;

            return {
                date: only_date,
                hour: only_hour
            }
        },
        /**
         * Rafraichir la salle d'attente
         * @returns
         */
        refreshSalleAttente() {
            this.salle_is_loading = true
            this.$store.dispatch('getConsultationsEnAttente', { auth_id: this.user_id}).then(() => {
                if (this.consultationsEnAttente.length > 0) {
                    this.salle_is_empty = false
                } else {
                    this.salle_is_empty = true
                }
                this.salle_is_loading = false
            })
        },
        
        /**
         * Rafraichir la salle d'attente
         * @returns 
         */
        refreshSuiteDeSoins() {
            this.$store.dispatch('getSuitesSoins', { auth_id: this.user_id}).then(() => {
                this.tableIsBusy = false
            })
        },

        selectSoin(soin, heure) {
            this.soin_selected = soin;
            this.heure_selected = heure
                // console.log('type', this.soin_selected)
        },
        

        monthsOfYear: function() {

            var month = new Array()
            month = [{
                    "french": "Janvier",
                    "english": "January"
                },
                {
                    "french": "Février",
                    "english": "February",
                },
                {
                    "french": "Mars",
                    "english": "March",
                },
                {
                    "french": "Avril",
                    "english": "April",
                },
                {
                    "french": "Mai",
                    "english": "May",
                },
                {
                    "french": "Juin",
                    "english": "May",
                },
                {
                    "french": "Juillet",
                    "english": "July",
                },
                {
                    "french": "Aout",
                    "english": "August",
                },
                {
                    "french": "Septembre",
                    "english": "September",
                },
                {
                    "french": "Octobre",
                    "english": "October",
                },
                {
                    "french": "Novembre",
                    "english": "November",
                },
                {
                    "french": "Decembre",
                    "english": "December",
                },
            ]

            return month
        },
        /**
         * Show select options in dropdown
         * @param {int} j_state
         * @param {string} selector
         */
        async openSelectOption(j_state, selector) {
            this.curr_state = openSelectOptions.openSelectOption(j_state, selector)
        },

        /**
         * Select option in dropdown
         * @param {string} selected_value
         * @param {string} selected_id
         * @param {string} selector
         * @param {string} model_selector
         */
        async selectOption(selected_value, selected_id, selector, model_selector) {
            this.curr_state = selectOption.chooseOption(selected_id, selector)

            switch (model_selector) {
                case 'jr':
                    this.jr_selected = selected_value;
                    break;
                case 'mm':
                    this.mm_selected = selected_value;
                    break;
                case 'cm':
                    this.consult_month_selected = selected_value;
                    this.monthConsultationsLoading = true
                    this.$store.dispatch('getCountMonthConsultations', { month: this.consult_month_selected.english }).then(
                        () => {
                            this.monthConsultationsLoading = false
                        }
                    )
            }
            console.log(selected_id); //  Recuperer ici l'ID de l'option choisi
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        /**
         * Traiter une conduite
         * @param {*} t_cat
         */
        treatCAT: function(t_cat, ccat) {
            this.selectedConduite = t_cat
            this.selectedMoment = ccat
        },

        /**
         *
         * @param {*} route
         */
        routeTo(route) {
            this.$router.push({ path: route })
        }
    }
}
